import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [-2000, 1500, 3000],
  minDistance: 1500,
  maxDistance: 8000,
  minAzimuthAngle: -(Math.PI / 2 - 0.5),
  maxAzimuthAngle: Math.PI / 2 - 0.5,
  minPolarAngle: 0.3,
  maxPolarAngle: Math.PI / 2 + 0.2,
  target: [0, 400, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 200,
}
